import React, { useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { Textarea } from "@/dentlab/src/components/ui/textarea";

interface JobNoteDialogProps {
	open: boolean;
	onClose: () => void;
	onSave: (content: string) => Promise<void>;
	initialContent?: string;
	title?: string;
}

export const JobNoteDialog: React.FC<JobNoteDialogProps> = ({
	open,
	onClose,
	onSave,
	initialContent = "",
	title = "Notiz hinzufügen",
}) => {
	const [content, setContent] = useState(initialContent);
	const [isSaving, setIsSaving] = useState(false);

	const handleSave = async () => {
		if (!content.trim()) return;
		
		setIsSaving(true);
		await onSave(content);
		setIsSaving(false);
		setContent("");
		onClose();
	};

	const handleClose = () => {
		setContent("");
		onClose();
	};

	return (
		<Dialog open={open} onOpenChange={handleClose}>
			<DialogContent className="sm:max-w-[625px]">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>
						Fügen Sie hier Ihre Notiz zum Auftrag hinzu.
					</DialogDescription>
				</DialogHeader>
				<div className="grid gap-4 py-4">
					<Textarea
						placeholder="Notiz eingeben..."
						value={content}
						onChange={(e) => setContent(e.target.value)}
						className="min-h-[200px]"
						autoFocus
					/>
				</div>
				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={handleClose}
						disabled={isSaving}
					>
						Abbrechen
					</Button>
					<Button
						type="button"
						onClick={handleSave}
						disabled={!content.trim() || isSaving}
					>
						{isSaving ? "Speichern..." : "Speichern"}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};